import styled from 'styled-components';
import { colors } from '@/constants';

export const Trilho = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: 99999999999;
  pointer-events: none;
  background-color: transparent;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease;
`;

export const Barra = styled.div`
  height: 100%;
  width: 0%;
  background-color: ${colors.green};
  transition: width 0.25s ease-out;
`;
